<ngx-bootstrap-multiselect
  *ngIf="myOptions"
  [options]="myOptions"
  [texts]="myTexts"
  [settings]="mySettings"
  [(ngModel)]="myModel"
  (ngModelChange)="onSelectionChange($event)"
></ngx-bootstrap-multiselect>
